import React from 'react';
import {useSelector} from 'react-redux';
import ListOfCollaboratorsDetailsHead from './components/list-of-collaborators-details-head';
import ListOfCollaboratorsDetailsContent from './components/list-of-collaborators-details-content';
import SaveChanges from './components/save-changes';
import SaveHiddenFieldsChanges from './components/save-hidden-fields-changes';
import './index.css';
import NewCollaboratorsLoading from './components/new-collaborators-loading';

function ListOfCollaboratorsDetails () {

	const changedStatus = useSelector(state => state.sharingDetailsReducer.getChangedStatus);
	const isHiddenFieldsChanging = useSelector(state => state.sharingDetailsReducer.isHiddenFieldsChanging);
	const findCollaborators = useSelector(state => state.sharingDetailsReducer.findCollaborators);

	return (
		<div className="list-of-collaborators-details">
			<ListOfCollaboratorsDetailsHead/>
			<ListOfCollaboratorsDetailsContent/>
			{changedStatus && <SaveChanges/>}
			{isHiddenFieldsChanging && <SaveHiddenFieldsChanges/>}
			{findCollaborators && findCollaborators.collaborators.length < findCollaborators.pages.totalRecords && <NewCollaboratorsLoading collaborators={findCollaborators}/>}
		</div>
	);
}

export default ListOfCollaboratorsDetails;
